<template>
  <SurveyQuestionInput
    :identifier="identifier"
    :index="index"
    :question="question"
    :is-required-answer="isRequiredAnswer"
    default-input-type="text"
    legacy-options-mode="buttons"
    @question-response="$emit('question-response', $event)"
  />
</template>
<script>
import SurveyQuestionInput from "@/app/common/components/utilities/SurveyQuestionInput.vue";

export default {
  name: "InputCompilatore",
  components: {
    SurveyQuestionInput,
  },
  props: {
    identifier: {
      type: String,
      default: "id",
    },
    index: {
      type: Number,
      default: 0,
    },
    question: {
      type: Object,
      default: () => ({
        a: null,
        k: null,
        o: null,
        q: "question",
        r: true,
        t: "text",
        v: false,
        bn: 1,
        cb: false,
        rc: {
          max: null,
          min: null,
          maxDate: { d: null, m: null, y: null },
          maxTime: { h: null, m: null },
          minDate: { d: null, m: null, y: null },
          minTime: { h: null, m: null },
          maxExact: null,
          minExact: null,
          ifIndexIs: { index: null, value: null },
        },
        ric: null,
        insert: null,
        dataInsert: false,
        si: {
          indexex: null,
          response: null,
        },
      }),
    },
    showQuestion: {
      type: Boolean,
      default: false,
    },
    isRequiredAnswer: {
      default: null,
    },
  },
};
</script>
